import { Star } from "lucide-react";

export const RatingStars = ({ value = 0, onChange, readOnly = false, size = "md" }) => {
  const sz = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "w-5 h-5";
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && onChange?.(n)}
          className={`${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} transition-transform`}
          data-testid={`rating-star-${n}`}
          aria-label={`${n} étoiles`}
        >
          <Star className={`${sz} ${n <= value ? "fill-[#FBBF24] text-[#FBBF24]" : "text-slate-300"}`} />
        </button>
      ))}
    </div>
  );
};

export default RatingStars;
